export default __webpack_public_path__ + "static/media/Step4.3ef42dec.svg";